export interface OneinchTokensResponse {
    tokens: Record<string, unknown>;
}
